import type { FaireProductEntity } from "../../entity_types/product";

export const p_v9nm5k5dxd: FaireProductEntity = {
  token: "p_v9nm5k5dxd",
  type: "product",
  name: "Thick Wool Fleece Men’S Crew Socks_CWMS03230",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/95376fa9854a60c0bbb5d7286ef459aa1ce6f78784590bbc27ed880e735ef195.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8a3ae7cd44b1d23c81fc17dbf5ecd236c0babc54762daf51d82096c4446ebd0e.jpeg",
    "https://cdn.faire.com/fastly/99bd33b77d3c8e4ef9e2eeb53f09226e2ef164ec5dc7d33943a5d9130cb136ce.jpeg",
    "https://cdn.faire.com/fastly/fb362f465a9e65a658ef1ec530087f1b2b914777a402ffa1ba6c3d4a601e9f12.jpeg",
    "https://cdn.faire.com/fastly/fa117c264eaaaf9756bcd917a9c8da63806d43587a8a7d7d32f5a1666376c7d0.jpeg",
    "https://cdn.faire.com/fastly/6d6423167ca95a01cae20d57f77f1f21b2492acdc604cfdb537d84bda3df385d.jpeg",
    "https://cdn.faire.com/fastly/627a99b0ba12e30d2500c9ffaf0ee348fc706cd3d01a5ae7ecfcae6484c58562.jpeg",
    "https://cdn.faire.com/fastly/70d319e7e3789759dd8d207d728c00fce7ff933fd867965ae0e42ee0d25ffa13.jpeg",
    "https://cdn.faire.com/fastly/468c4436512565cbcb2a0c37df0d7403ece3d4d1ee88dbcf4b012e0d822503d5.jpeg",
    "https://cdn.faire.com/fastly/1d8fbaf544c535f81e113592290e559bfd270e9905d9fafc7a0b724b9533b23e.jpeg",
    "https://cdn.faire.com/fastly/29a09c30259b5c3dce63fc2c31ab49b75936852006ecfa532acb18181e9876d2.jpeg",
    "https://cdn.faire.com/fastly/3997d59cb44fc208bd94d116550cce47271166d6ae90edd24a6a0ce220385c6d.jpeg",
  ],
  priceDollars: 3.75,
  description:
    "•Material: 70% cotton, 27% polyester, 3% spandex\n•Pattern: Solid color\n\n⭐⭐⭐☆☆ Above Average: Good quality, suitable for everyday wear.\n\nProduct types available during this period: Women's mid-calf socks, cute bubble-trimmed socks, soft cotton socks, everyday fall socks, polka dot socks, vintage striped socks, fashionable mid-calf socks, Japanese-style socks, colorful mid-calf socks, comfortable casual socks, girls' knitted socks, cute unisex socks, classic everyday socks, simple everyday socks, women's autumn socks, soft texture socks, comfortable and durable socks, Korean-style mid-calf socks, women's striped knitted socks, fashionable basic socks, girls' boneless socks, casual preppy socks, comfortable fall and winter socks, Instagram-inspired mid-calf socks.",
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:42.793Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
